import React, { MouseEventHandler, useCallback } from 'react'
import TextButton from 'LuxKit/Button/TextButton'
import LineShoppingCartIcon from 'LuxKit/Icons/line/LineShoppingCartIcon'

interface Props {
  onCtaClick: (shouldAddToCart: boolean) => void;
  showAddToCart: boolean;
}

function PropertyAvailableRateOptionCtas({ onCtaClick, showAddToCart }: Props) {
  const onClick = useCallback<MouseEventHandler<HTMLButtonElement>>(event => {
    const shouldAddToCart = !!event.currentTarget.dataset.addToCart
    onCtaClick(shouldAddToCart)
  }, [onCtaClick])

  return <>
    <TextButton
      onClick={onClick}
      kind="primary"
      size="large"
    >
      Book now
    </TextButton>
    {showAddToCart && <TextButton
      onClick={onClick}
      kind="secondary"
      startIcon={<LineShoppingCartIcon />}
      size="large"
      data-add-to-cart
    >
      Add to cart
    </TextButton>}
  </>
}

export default React.memo(PropertyAvailableRateOptionCtas)
